export default __webpack_public_path__ + "static/viscom_preview-99d60d292990bc3fa3c6d0e1c952bfb8.mp4";